import { getClickedPersonaAfterFavoriteRemoved } from '../../../utils/navigationReducerHelper';
import type { NavigationState } from '../../../state/view/navigationState';

export function getStateAfterFavoriteRemoved(
    state: NavigationState,
    displayedHubPersonaIds: string[],
    removedHubPersonaId: string
): NavigationState {
    const newClickedHubPersonaId = getClickedPersonaAfterFavoriteRemoved(
        displayedHubPersonaIds,
        removedHubPersonaId
    );
    const newClickedPersona = newClickedHubPersonaId
        ? {
              hubPersonaId: newClickedHubPersonaId,
              origin: state.clickedHubPersona ? state.clickedHubPersona.origin : 'personaList',
          }
        : undefined;

    return {
        ...state,
        personaListCheckedHubPersonaDetails: [],
        clickedHubPersona: newClickedPersona,
    };
}
